import { configureStore } from '@reduxjs/toolkit';
import commonReducer from './common.slice';
import chatReducer from './chat.slice';

export const store = configureStore({
  reducer: {
    common: commonReducer,
    chat: chatReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;